// extracted by mini-css-extract-plugin
export default {"icon-container":"cluster-selection-view_icon-container__1KUiQ"};